import { createRouter, createWebHistory } from "vue-router";

import signin from "@/components/signin";
import admin from "@/components/admin";
import dashboard from "@/components/dashboard";
import adminUser from "@/components/adminUser";
import fieldWorker from "@/components/fieldWorker";

import welcomePage from "@/components/welcomePage";
import startGame from "@/components/startGame";

import adminQuestionOnly from "@/components/adminQuestionOnly";
import paymentPage from "@/components/paymentPage";

import nirItzhakGeneral from "@/components/evenementsPonctuels/nirItzhakGeneral";
import EinDorGeneral from "@/components/evenementsPonctuels/EinDorGeneral";
import runningGame from "@/components/runningGame";
import hanukaEinDor from "@/components/evenementsPonctuels/hanukaEinDor";
import demoGame from "@/components/demoGame";
import testing from "@/components/testing";
import play from "@/components/play";
import mitspeIlan from "@/components/evenementsPonctuels/mitspeIlan";
import plansAdmin from "@/components/plansAdmin";
import pricingPage from "@/components/pricingPage";
import subscriptionSuccess from "@/components/subscriptionSuccess";

import page210 from "@/components/evenementsPonctuels/210";
import page210Admin from "@/components/evenementsPonctuels/210admin";
import howItWorks from "@/components/howItWorks";
import hanuka2026 from "@/components/hanuka2026";
import yaffoCroisades from "@/components/evenementsPonctuels/yaffoCroisades";
import pessahFlyer from "@/components/evenementsPonctuels/pessahFlyer";
import einDorKfarMizr from "@/components/evenementsPonctuels/einDorKfarMizr";
import hanukaMaanit22 from "@/components/evenementsPonctuels/hanukaMaanit22";
import purimEinDor from "@/components/evenementsPonctuels/purimEinDor";
import parkTavor from "@/components/evenementsPonctuels/parkTavor";
import resultsByPoints from "@/components/resultsByPoints";
import nahalMassha from "@/components/evenementsPonctuels/nahalMassha";
import nahalMasshaWest from "@/components/evenementsPonctuels/nahalMasshaWest";
import nahalMasshaEast from "@/components/evenementsPonctuels/nahalMasshaEast";
import einDorFit from "@/components/evenementsPonctuels/einDorFit";
import einDorFitShort from "@/components/evenementsPonctuels/einDorFitShort";

import evolutionTable from "@/components/evolutionTable";
import photoComponent from "@/components/photoComponent";
import akkoOldCity from "@/components/evenementsPonctuels/akkoOldCity";
import einDorNahalTavor from "@/components/evenementsPonctuels/einDorNahalTavor";
import nahalMerhavia from "@/components/evenementsPonctuels/nahalMerhavia";
import nahalTavor from "@/components/evenementsPonctuels/nahalTavor";
import gazitLocalTime from "@/components/evenementsPonctuels/gazitLocalTime";
import RNmaaleKish from "@/components/evenementsPonctuels/RNmaaleKish";
import rndabburiya from "@/components/evenementsPonctuels/rndabburiya";
import hanukaRamatDavid23 from "@/components/evenementsPonctuels/hanukaRamatDavid23";

import flyerEifoanyShelters from "@/components/evenementsPonctuels/flyerEifoanyShelters";

import home from "@/components/home";
import gameEntry from "@/components/gameEntry";
import results from "@/components/results";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/plans-admin", name: "plansAdmin", component: plansAdmin },
    { path: "/pricing", name: "pricingPage", component: pricingPage },
    {
      path: "/subscription-success",
      name: "subscriptionSuccess",
      component: subscriptionSuccess,
    },
    { path: "/admin", name: "admin", component: admin },
    { path: "/dashboard", name: "dashboard", component: dashboard },
    { path: "/adminUser", name: "adminUser", component: adminUser },
    { path: "/field", name: "fieldWorker", component: fieldWorker },
    { path: "/purimEinDor", name: "purimEinDor", component: purimEinDor },
    {
      path: "/hanukaMaanit22",
      name: "hanukaMaanit22",
      component: hanukaMaanit22,
    },
    { path: "/parkTavor", name: "parkTavor", component: parkTavor },
    {
      path: "/flyerEifoanyShelters",
      name: "flyerEifoanyShelters",
      component: flyerEifoanyShelters,
    },
    {
      path: "/hanukaRamatDavid23",
      name: "hanukaRamatDavid23",
      component: hanukaRamatDavid23,
    },
    { path: "/rndabburiya", name: "rndabburiya", component: rndabburiya },
    {
      path: "/resultsByPoints",
      name: "resultsByPoints",
      component: resultsByPoints,
    },
    {
      path: "/einDorFitShort",
      name: "einDorFitShort",
      component: einDorFitShort,
    },
    { path: "/einDorFit", name: "einDorFit", component: einDorFit },
    {
      path: "/nahalMasshaEast",
      name: "nahalMasshaEast",
      component: nahalMasshaEast,
    },
    {
      path: "/nahalMasshaWest",
      name: "nahalMasshaWest",
      component: nahalMasshaWest,
    },
    { path: "/nahalMassha", name: "nahalMassha", component: nahalMassha },
    { path: "/paymentPage", name: "paymentPage", component: paymentPage },
    { path: "/mitspeIlan", name: "mitspeIlan", component: mitspeIlan },
    {
      path: "/adminQuestionOnly",
      name: "adminQuestionOnly",
      component: adminQuestionOnly,
    },
    { path: "/startGame", name: "startGame", component: startGame },
    { path: "/results", name: "results", component: results },
    { path: "/signin", name: "signin", component: signin },
    { path: "/nahalMerhavia", name: "nahalMerhavia", component: nahalMerhavia },
    {
      path: "/gazitLocalTime",
      name: "gazitLocalTime",
      component: gazitLocalTime,
    },
    { path: "/RNmaaleKish", name: "RNmaaleKish", component: RNmaaleKish },
    { path: "/nahalTavor", name: "nahalTavor", component: nahalTavor },
    {
      path: "/einDorNahalTavor",
      name: "einDorNahalTavor",
      component: einDorNahalTavor,
    },
    { path: "/akkoOldCity", name: "akkoOldCity", component: akkoOldCity },
    {
      path: "/photoComponent",
      name: "photoComponent",
      component: photoComponent,
    },
    {
      path: "/evolutionTable",
      name: "evolutionTable",
      component: evolutionTable,
    },
    {
      path: "/einDorKfarMizr",
      name: "einDorKfarMizr",
      component: einDorKfarMizr,
    },
    {
      path: "/yaffoCroisades",
      name: "yaffoCroisades",
      component: yaffoCroisades,
    },
    { path: "/pessahFlyer", name: "pessahFlyer", component: pessahFlyer },
    { path: "/play", name: "play", component: play },
    { path: "/testing", name: "testing", component: testing },
    { path: "/demoGame", name: "demoGame", component: demoGame },
    { path: "/hanukaEinDor", name: "hanukaEinDor", component: hanukaEinDor },
    { path: "/runningGame", name: "runningGame", component: runningGame },
    { path: "/EinDorGeneral", name: "EinDorGeneral", component: EinDorGeneral },
    {
      path: "/nirItzhakGeneral",
      name: "nirItzhakGeneral",
      component: nirItzhakGeneral,
    },
    { path: "/210", name: "page210", component: page210, meta: { hideNav: true } },
    { path: "/210admin", name: "page210Admin", component: page210Admin },
    { path: "/howItWorks", name: "howItWorks", component: howItWorks, meta: { hideNav: true } },
    { path: "/hanuka2026", name: "hanuka2026", component: hanuka2026, meta: { hideNav: true } },
    { path: "/home", name: "homePage", component: home, meta: { hideNav: true } },
    { path: "/:gameName", name: "gameEntry", component: gameEntry },
    { path: "/", name: "home", component: home, meta: { hideNav: true } },
    { path: "/welcomePage", name: "welcomePage", component: welcomePage },
  ],
});

export default router;
